import { useMutation } from "@tanstack/react-query";
import { ContactInformationService } from "../../services/contactInformation.service";
import { IContactInformationData } from "../types";

export const useContactInformationMutations = () => {
  const { mutate: updateById } = useMutation<boolean, Error, IContactInformationData>({
    mutationFn: async ({ contactInformation }: IContactInformationData) =>
      ContactInformationService.updateById(contactInformation).then((res) => res.data),
  });

  return {
    updateById,
  };
};
